import React, { FC } from "react";

import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { ActivityLog } from "../../../store/pomeriumApi";

type ActivityLogPickerProps = {
  allowEmpty: boolean;
  selectedId?: string;
  activityLogs?: ActivityLog[];
  onChange: (evt: SelectChangeEvent<string>) => void;
};
const ActivityLogPicker: FC<ActivityLogPickerProps> = ({
  allowEmpty,
  selectedId,
  activityLogs,
  onChange,
}) => {
  const items =
    activityLogs?.map((c) => ({
      value: c.id,
      title: `${c.updatedAt} | ${c.id}`,
    })) || [];
  if (allowEmpty) {
    items.splice(0, 0, {
      value: "",
      title: "",
    });
  }
  if (!items?.find((i) => i.value === selectedId)) {
    items.push({
      value: selectedId || "",
      title: selectedId || "",
    });
  }
  return (
    <FormControl fullWidth size="small">
      <Select value={selectedId || ""} onChange={onChange}>
        {items.map((i) => (
          <MenuItem key={i.value} value={i.value}>
            {i.title ? i.title : <em>None</em>}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default ActivityLogPicker;
